import { mapGetters } from 'vuex';
export default {
    data(){
        return {
            defaulttype:"info"
        }
    },
    methods: {
        initMessage() {
            this.$store.commit('messages/MESSAGES_INIT_MESSAGE')
        },        
        setMessage(statuscode,message){
            let view=this.getView(statuscode)
            
            if(view==null) {
                this.$store.commit('messages/MESSAGES_SET_MESSAGE',message)
                this.$store.commit('messages/MESSAGES_SET_STATUS',statuscode)
                this.$store.commit('messages/MESSAGES_SET_SHOW',true)    
            } else {
                this.$store.commit('messages/MESSAGES_INIT_MESSAGE')               
                this.$router.replace({name:view})
            }
        },
        getView(statuscode){
            let result = null
            if(statuscode) {
                let tmp = this.$store.getters['messages/actiondata'](statuscode)
                result = tmp.view
            }
            return result   
        }
               
    },
    computed:{
        
        message(){return this.$store.getters['messages/data']('message')},
        statuscode(){return this.$store.getters['messages/data']('statuscode')},
        showmessage:{
            get(){return this.$store.getters['messages/data']('showmessage')},
            set(value){this.$store.commit('messages/MESSAGES_SET_SHOW',value)}
        },
        messagetype(){
            
            let result = this.defaulttype
            if(this.statuscode) {
                let tmp = this.$store.getters['messages/actiondata'](this.statuscode)
                result = tmp.type
            }
            return result                     
        },
        
    }
}
